import { AppUpdatePage } from './app-update.page'

import type { RouteObject } from 'react-router-dom'

const AppUpdateRoutes: RouteObject[] = [
  {
    path: 'app-update',
    element: <AppUpdatePage />,
  },
]

export { AppUpdateRoutes }
